// extracted by mini-css-extract-plugin
export default {"wrapper":"PageWrapper_wrapper__8PNYF"};